import { Main } from '@axo/form/feature/axo-form-v2/lib/forms/Sweden/LoanApplication/Main/Main';
import { mount } from '../../mount.v2';

mount({
  View: Main,
  type: 'main',
  brand: 'freedomfinance.se',
});
